import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { ProductDimensionViewTypes } from "@temp/components/ProductDimensionView/types";
import React, { useCallback } from "react";
import { useIntl } from "react-intl";
import * as S from "./styles";
export var ProductDimensionViewsTabs = function ProductDimensionViewsTabs(_ref) {
  var view = _ref.view,
      setView = _ref.setView,
      product = _ref.product;
  var intl = useIntl();
  var isMinimalist = product && product.productType.name === "door-minimalist";
  var aboveHandle = useCallback(function () {
    setView(ProductDimensionViewTypes.space_above);
  }, [setView]);
  var trackHandle = useCallback(function () {
    setView(ProductDimensionViewTypes.track);
  }, [setView]);
  return React.createElement(S.Wrapper, null, React.createElement(S.Button, {
    onClick: useCallback(function () {
      setView(ProductDimensionViewTypes.all);
    }, [setView]),
    active: view === ProductDimensionViewTypes.all
  }, React.createElement("span", null, intl.formatMessage(_defineProperty({
    defaultMessage: "Show all",
    "id": "@next.components.molecules.ProductDimensionViewsTabs.ProductDimensionViewsTabs.4147597655"
  }, "id", "@next.components.molecules.ProductDimensionViewsTabs.ProductDimensionViewsTabs.4147597655")))), React.createElement(S.Button, {
    onClick: useCallback(function () {
      setView(ProductDimensionViewTypes.door);
    }, [setView]),
    active: view === ProductDimensionViewTypes.door
  }, React.createElement("span", null, intl.formatMessage(_defineProperty({
    defaultMessage: "Show door",
    "id": "@next.components.molecules.ProductDimensionViewsTabs.ProductDimensionViewsTabs.2270813284"
  }, "id", "@next.components.molecules.ProductDimensionViewsTabs.ProductDimensionViewsTabs.2270813284")))), React.createElement(S.Button, {
    onClick: useCallback(function () {
      setView(ProductDimensionViewTypes.opening);
    }, [setView]),
    active: view === ProductDimensionViewTypes.opening
  }, React.createElement("span", null, intl.formatMessage(_defineProperty({
    defaultMessage: "Show opening",
    "id": "@next.components.molecules.ProductDimensionViewsTabs.ProductDimensionViewsTabs.917310715"
  }, "id", "@next.components.molecules.ProductDimensionViewsTabs.ProductDimensionViewsTabs.917310715")))), !isMinimalist && React.createElement(S.Button, {
    onClick: trackHandle,
    active: view === ProductDimensionViewTypes.track
  }, React.createElement("span", null, intl.formatMessage(_defineProperty({
    defaultMessage: "Track length",
    "id": "@next.components.molecules.ProductDimensionViewsTabs.ProductDimensionViewsTabs.4190805166"
  }, "id", "@next.components.molecules.ProductDimensionViewsTabs.ProductDimensionViewsTabs.4190805166")))), !isMinimalist && React.createElement(S.Button, {
    onClick: aboveHandle,
    active: view === ProductDimensionViewTypes.space_above
  }, React.createElement("span", null, intl.formatMessage(_defineProperty({
    defaultMessage: "Space above",
    "id": "@next.components.molecules.ProductDimensionViewsTabs.ProductDimensionViewsTabs.2943304725"
  }, "id", "@next.components.molecules.ProductDimensionViewsTabs.ProductDimensionViewsTabs.2943304725")))));
};